import React, {Component, Fragment} from "react";
import {
  Button,
  Col,
  FormGroup,
  FormText,
  Input,
  InputGroup,
  Label,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane
} from "reactstrap";
import {
  formsCheckboxUpdater,
  formsDataUpdater,
  formsMultiUpdater,
  formsUpdater,
  getFormFieldValue,
  zPad
} from "../../Applications/shared/shared";
import classnames from 'classnames';
import {hourMarks, minMarks} from "../../../constants/MiscData";
import {EventClient} from "../../../util/eventClient";
import {LMSUserPicker} from "../../../components/LMSUserPicker/LMSUserPicker";
import {deleteData, getData, postData} from "../../../api/doLogin";
import {isNumber} from "../../../util/numberhelpers";
import "./entry.css";

import {
  addHours,
  forceSingleTimeZone,
  formatDate,
  formatDateLocal,
  formatTimeFromEpoch,
  makeDateObj, parseSeconds
} from "../../../util/datehelpers";
import moment from "moment";
import {howHearOptions, recurFrequency, recurStopList} from "../constants/CalendarConstants";
import {TheColorPicker} from "../../../components/Shared/TheColorPicker";
import AAREntryEditor from "./AAREntryEditor";
import {TransferCalendarDialog} from "../modals/TransferCalendarDialog";
import {RescheduleCalendarDialog} from "../modals/RescheduleCalendarDialog";
import {MessageDialog} from "../modals/MessageDialog";
import {CancelCalendarDialog} from "../modals/CancelCalendarDialog";

export default class CalendarEntryEditor extends Component {

  constructor(props) {
    super(props);
    this.state = {
      appttypes: [],
      dataLoaded: false,
      formData: {}, //appttype: "-1" Left off here. Make edit be ID and retrieve Entry data with appt Constants.
      showLMSPicker: false,
      activeTab: "1",
      showTransfer: false,
      showReschedule: false,
      showMessage: false,
      showCancel: false,
    };
    if (props['addSelection'] && Object.keys(props['addSelection']).length > 1) {
      const tempEvent = {};
      tempEvent['startdate'] = formatDateLocal(props.addSelection['start']);
      tempEvent['starthour'] = props.addSelection['start'].getHours();
      tempEvent['startmin'] = props.addSelection['start'].getMinutes();

      const endAt = props.addSelection['end'] || addHours(props.addSelection['start'], 1);
      tempEvent['enddate'] = formatDateLocal(endAt);
      tempEvent['endhour'] = endAt.getHours();
      tempEvent['endmin'] = endAt.getMinutes();

      if (tempEvent['starthour'] === 0 && tempEvent['startmin'] === 0 && tempEvent['endhour'] === 0 && tempEvent['endmin'] === 0) {
        tempEvent['allDay'] = false;
        tempEvent['enddate'] = "";
        tempEvent['starthour'] = "";
        tempEvent['startmin'] = "";
        tempEvent['endhour'] = "";
        tempEvent['endmin'] = "";
      }
      this.state.formData = tempEvent;
    }
    this.originalDate = null;
    this.duration = 120;
  }

  componentWillMount() {
    EventClient.on(this.props.saveEvent, () => this.saveExternal(), this.props.eventName);
    EventClient.on(this.props.removeEvent, () => this.removeExternal(), this.props.eventName);
    EventClient.on("CALENDAR_ATTACH_LEAD", (lead) => this.attachLMSEntry(lead), this.props.eventName);
    if (this.props.attachedLead) {
      this.attachLMSEntry(this.props.attachedLead, () => {
        this.getDBConstants();
      });
    } else {
      this.getDBConstants();
    }

  }

  showTransfer() {
    this.setState({showTransfer: true});
  }

  showEmail() {
    if (this.state['formData'] && this.state['formData']['attachedLeads'] && this.state['formData']['attachedLeads']['id']) {
      this.setState({showMessage: true});
    } else {
      alert("Please select a lead to send an email to first");
    }
  }

  showCancel() {
    this.setState({showCancel: true});
  }

  apptChange(oldDate, newDate) {
    if (!this.props.edit) return;
    const same = Object.keys(this.originalDate).every((key) => {
      return String(this.originalDate[key]) === String(this.state.formData[key]);
    });
    this.props.onDateChange && this.props.onDateChange(same);
  }

  showReschedule() {
    if (!this.preSave()) return;
    this.setState({showReschedule: true});
  }

  componentWillUnmount() {
    EventClient.off(this.props.saveEvent, () => this.saveExternal(), this.props.eventName);
    EventClient.off(this.props.removeEvent, () => this.removeExternal(), this.props.eventName);
    EventClient.off("CALENDAR_ATTACH_LEAD", (lead) => this.attachLMSEntry(lead), this.props.eventName);
  }

  saveExternal() {
    // console.log(this.state.formData);
    this.save((resp) => {
      if (this.props.onSave) {
        this.props.onSave(resp);
      }
    })
  }

  saveInternval() {

  }

  getDBConstants() {
    const self = this;
    getData("calendar/retrieve/" + this.props.edit || 0, {}, this.props.token)
      .then((data) => {
        if (data.status === "Success") {
          let responseStateData = {appttypes: data.data.apptTypes, dataLoaded: true};
          if (isNumber(self.props.edit)) {
            if (data.data.event.length > 0) {
              // console.log(data.data.event);
              const tempEvent = data.data.event[0];
              const start = forceSingleTimeZone(formatTimeFromEpoch(tempEvent.starttime));
              const end = forceSingleTimeZone(formatTimeFromEpoch(tempEvent.endtime));
              tempEvent['startdate'] = formatDateLocal(start);
              tempEvent['starthour'] = start.getHours();
              tempEvent['startmin'] = start.getMinutes();
              tempEvent['enddate'] = formatDateLocal(end);
              tempEvent['endhour'] = end.getHours();
              tempEvent['endmin'] = end.getMinutes();
              tempEvent['allDay'] = Number(tempEvent.allDay) === 1;
              this.originalDate = {
                startdate: tempEvent['startdate'],
                starthour: tempEvent['starthour'],
                startmin: tempEvent['startmin'],
                enddate: tempEvent['enddate'],
                endhour: tempEvent['endhour'],
                endmin: tempEvent['endmin'],
                allDay: tempEvent['allDay'],
                start, end
              };
              responseStateData['formData'] = tempEvent;
            } else {
              if (self.props.onClose) {
                setTimeout(() => self.props.onClose(), 200);
                return;
              }
            }
            if (data.data.leads.length > 0) {
              responseStateData['formData']['attachedLeads'] = data.data.leads[0];
            }
          }
          self.setState(responseStateData, () => {
            self.calculateDuration();
            if (self.state.formData.subStatus === 3 || self.state.formData.aar_status === 3) {
              self.props.onFollowup && self.props.onFollowup(responseStateData['formData']['attachedLeads'] && responseStateData['formData']['attachedLeads']['id'] || "");
            }
          });
        }
      }).catch((error) => {
      console.log(error);
    });
  }

  preSave() {
    if (typeof this.state.formData.appttype === "undefined") {
      EventClient.emit("TOAST_ERROR", "Select Appointment Type");
      return false;
    }
    if (!this.state.formData.startdate) {
      EventClient.emit("TOAST_ERROR", "You must choose a start date");
      return false;
    }
    if (!this.state.formData.enddate) {
      EventClient.emit("TOAST_ERROR", "You must choose a start date");
      return false;
    }
    if (this.state.formData.appttype !== "-1" && this.state.formData.appttype !== -1) {
      if (typeof getFormFieldValue(this.state.formData['attachedLeads']) !== "object") {
        EventClient.emit("TOAST_ERROR", "You must attach a lead for this type of appointment");
        return false;
      }
    }
    return true;
  }

  save(cb) {
    const self = this;
    const payload = {formData: this.state.formData || null, action: isNumber(self.props.edit) ? "update" : "add"};
    if (!this.preSave()) return;
    if (this.state.formData.appttype === "-1" && this.state.formData.repeat) {
      payload['formData'] = this.calcRepeat(this.state.formData);
    }
    if (this.props.edit && payload['formData']) {
      payload['formData']['id'] = this.props.edit;
    }
    if (this.props.followup) payload['followup'] = 11;
    if (this.state.formData.appttype === "-1" || this.state.formData.appttype === -1) {
      payload['formData']['attachedLeads'] = null;
      delete payload['formData']['attachedLeads'];
    }
    // return console.log(payload);
    postData(`calendar/save/${this.props.calId}`, payload, this.props.token)
      .then((data) => {
        // console.log(data);
        if (data.status === "Success") {
          if (!isNumber(self.props.edit)) {
            cb({...this.state.formData, id: data.data.id});
          } else {
            cb({...this.state.formData});
          }
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  calcRepeat(data) {
    data = {...data};
    if (data.repeat && data.appttype === "-1") {
      //read start date
      const original = {
        start: makeDateObj(data.startdate, data.starthour, data.startmin),
        end: makeDateObj(data.enddate, data.endhour, data.endmin)
      }
      data.entries = [];
      if (data.repeats === "daily" && data.recurStop === "by") {
        this.countDailyToDate(data, original, makeDateObj(data.recurStopBy, data.starthour, data.startmin), Number(data.freq || 1));
      } else if (data.repeats === "daily" && data.recurStop === "after") {
        this.countDailyForX(data, original, Number(data.recurStopAfter || 1), Number(data.freq || 1));
      } else if (data.repeats === "weekly") {
        const daysOfWeek = [];
        data.sun && daysOfWeek.push(0);
        data.mon && daysOfWeek.push(1);
        data.tues && daysOfWeek.push(2);
        data.wed && daysOfWeek.push(3);
        data.thurs && daysOfWeek.push(4);
        data.fri && daysOfWeek.push(5);
        data.sat && daysOfWeek.push(6);

        if (data.recurStop === "by") {
          this.countWeeklyToDate(data, original, daysOfWeek, makeDateObj(data.recurStopBy, data.starthour, data.startmin), Number(data.freq || 1));
        } else if (data.recurStop === "after") {
          this.countWeeklyForX(data, original, daysOfWeek, Number(data.recurStopAfter || 1), Number(data.freq || 1));
        }
      }
      return data;
    } else {
      return data;
    }
  }

  countDailyToDate(data, original, stopOnDate, freq) {
    if (original.start > stopOnDate) return;
    data.entries.push(this.buildRecord({...data}, {...original}))
    original.start.addHours(24 * freq);
    original.end.addHours(24 * freq);
    this.countDailyToDate(data, original, stopOnDate, freq);
  }

  countWeeklyToDate(data, original, daysOfWeek, stopOnDate, freq) {
    for (var i = original.start.getUTCDay(); i <= 7; i++) {
      if (original.start > stopOnDate) return;
      if (daysOfWeek.includes(i)) data.entries.push(this.buildRecord({...data}, {...original}))
      original.start.addHours(24);
      original.end.addHours(24);
    }
    original.start.addHours(24 * (freq - 1) * 7);
    original.end.addHours(24 * (freq - 1) * 7);
    this.countWeeklyToDate(data, original, daysOfWeek, stopOnDate, freq);
  }

  countDailyForX(data, original, stopAfter, freq) {
    if (data.entries.length >= stopAfter) return;
    data.entries.push(this.buildRecord({...data}, {...original}))
    original.start.addHours(24 * freq);
    original.end.addHours(24 * freq);
    this.countDailyForX(data, original, stopAfter, freq);
  }

  countWeeklyForX(data, original, daysOfWeek, stopAfter, freq) {
    if (0 >= stopAfter) return;
    for (var i = original.start.getUTCDay(); i <= 7; i++) {
      if (daysOfWeek.includes(i)) data.entries.push(this.buildRecord({...data}, {...original}))
      original.start.addHours(24);
      original.end.addHours(24);
    }
    original.start.addHours(24 * (freq - 1) * 7);
    original.end.addHours(24 * (freq - 1) * 7);
    this.countWeeklyForX(data, original, daysOfWeek, stopAfter - 1, freq);
  }

  buildRecord(data, original) {
    return {
      appttype: data.appttype,
      colorOverride: data.colorOverride || "",
      details: data.details || "",
      endhour: data.endhour || "0",
      endmin: data.endmin || "0",
      location: data.location || "",
      notes: data.notes || "",
      starthour: data.starthour || "0",
      startmin: data.startmin || "0",
      subject: data.subject || "",
      startdate: formatDate(original.start),
      enddate: formatDate(original.end),
    }
  }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      }, () => {
        this.props.onTabChange && this.props.onTabChange(tab);
      });
    }
  }

  dateBuilder(when) {
    let self = this;
    if (!self.state.formData[when + 'hour'] && self.state.formData[when + 'min'] !== 0) return "";
    if (!self.state.formData[when + 'min'] && self.state.formData[when + 'min'] !== 0) return "";
    return "".concat(self.state.formData[when + 'date'], " ", zPad(String(self.state.formData[when + 'hour'] || 0), 2), ":", zPad(String(self.state.formData[when + 'min'] || 0), 2), ":00");
  }

  calculateDuration() {
    const startDate = this.momentDate(this.dateBuilder("start"));
    const endDate = this.momentDate(this.dateBuilder("end"));
    if (startDate.isValid() && endDate.isValid()) {
      this.duration = endDate.diff(startDate, 'minutes')
    } else {
      this.duration = 120;
    }
  }

  momentDate(dateString) {
    return moment(dateString, "YYYY-MM-DD HH:mm:ss", true);
  }

  dateValidator(startUpdated) {
    const startDate = this.momentDate(this.dateBuilder("start"));
    const endDate = this.momentDate(this.dateBuilder("end"));
    if (startUpdated === 'start') {
      if (startDate.isValid() && endDate.isValid()) {
        //Update end time to keep duration
        const newEnd = startDate.clone().add(this.duration, 'minutes');
        formsMultiUpdater({
          enddate: newEnd.format("YYYY-MM-DD"),
          endhour: newEnd.hours(),
          endmin: newEnd.minutes()
        }, this.state.formData, this, () => {
          this.apptChange();
        });
        // if (startDate.isAfter(endDate)) {
        //   formsMultiUpdater({
        //     enddate: this.state.formData.startdate,
        //     endhour: this.state.formData.starthour || 0,
        //     endmin: this.state.formData.startmin || 0
        //   }, this.state.formData, this, () => {
        //     this.apptChange();
        //   });
        // } else {
        //   this.apptChange();
        // }
      } else if (startDate.isValid() && !endDate.isValid()) {
        const newEnd = startDate.clone().add(this.duration, 'minutes');
        formsMultiUpdater({
          enddate: newEnd.format("YYYY-MM-DD"), //this.state.formData.startdate,
          endhour: newEnd.hours(), //this.state.formData.starthour || 0,
          endmin: newEnd.minutes() //this.state.formData.startmin || 0
        }, this.state.formData, this, () => {
          this.apptChange();
        });
      }
    } else {
      //end was the one changed
      if (endDate.isValid() && startDate.isValid()) {
        if (endDate.isBefore(startDate)) {
          formsMultiUpdater({
            startdate: this.state.formData.enddate,
            starthour: this.state.formData.endhour || 0,
            startmin: this.state.formData.endmin || 0
          }, this.state.formData, this, () => {
            this.calculateDuration();
            this.apptChange();
          });
        } else {
          this.calculateDuration();
          this.apptChange();
        }
      } else if (endDate.isValid() && !startDate.isValid()) {
        const newStart = endDate.clone().subtract(this.duration, 'minutes');
        formsMultiUpdater({
          startdate: newStart.format("YYYY-MM-DD"), //this.state.enddate.formData,
          starthour: newStart.hours(), //this.state.formData.endhour || 0,
          startmin: newStart.minutes() //this.state.formData.endmin || 0
        }, this.state.formData, this, () => {
          this.apptChange();
        });
      }
    }
  }

  repeatForm() {
    if (this.state.formData.appttype !== "-1" || !this.state.formData.repeat) return null;
    return (<Fragment>
        <Row>
          <Col xs="4" lg="3">
            <FormGroup>
              <Label for="repeats">Repeats</Label>
              <Input type="select" id="repeats" placeholder=""
                     value={getFormFieldValue(this.state.formData['repeats'])}
                     onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
              >
                <option value={""} disabled>Please Select...</option>
                {(recurFrequency || []).map((val, i) => {
                  return <option key={i} value={val.id}>{val.display}</option>
                })}
              </Input>
            </FormGroup>
          </Col>
          {this.state.formData.repeats === "daily" && (
            <Col xs="4" lg="3">
              <FormGroup inline check style={{paddingTop: 28}}>
                Every
                <Input id="freq" placeholder=""
                       size={"4"}
                       value={getFormFieldValue(this.state.formData['freq'] || "1")}
                       onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                />
                day(s)
              </FormGroup>
            </Col>
          )}

          {this.state.formData.repeats === "weekly" && (
            <Fragment>
              <Col xs="4" lg="3">
                <FormGroup inline check style={{paddingTop: 28}}>
                  Every
                  <Input id="freq" placeholder=""
                         size={"4"}
                         value={getFormFieldValue(this.state.formData['freq'] || "1")}
                         onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                  />
                  week(s)
                </FormGroup>
              </Col>
              <Col xs="6" lg="6">
                <FormGroup inline check style={{paddingTop: 35}}>
                  <Input className="form-check-input"
                         type="checkbox"
                         id="mon"
                         defaultChecked={getFormFieldValue(this.state.formData['mon'])}
                         onChange={(evt) => formsCheckboxUpdater(evt, this.state['formData'], this)}
                  />
                  <Label className="form-check-label" check htmlFor="mon">M</Label>
                </FormGroup>
                <FormGroup inline check style={{paddingTop: 35}}>
                  <Input className="form-check-input"
                         type="checkbox"
                         id="tues"
                         defaultChecked={getFormFieldValue(this.state.formData['tues'])}
                         onChange={(evt) => formsCheckboxUpdater(evt, this.state['formData'], this)}
                  />
                  <Label className="form-check-label" check htmlFor="tues">T</Label>
                </FormGroup>
                <FormGroup inline check style={{paddingTop: 35}}>
                  <Input className="form-check-input"
                         type="checkbox"
                         id="wed"
                         defaultChecked={getFormFieldValue(this.state.formData['wed'])}
                         onChange={(evt) => formsCheckboxUpdater(evt, this.state['formData'], this)}
                  />
                  <Label className="form-check-label" check htmlFor="wed">W</Label>
                </FormGroup>
                <FormGroup inline check style={{paddingTop: 35}}>
                  <Input className="form-check-input"
                         type="checkbox"
                         id="thurs"
                         defaultChecked={getFormFieldValue(this.state.formData['thurs'])}
                         onChange={(evt) => formsCheckboxUpdater(evt, this.state['formData'], this)}
                  />
                  <Label className="form-check-label" check htmlFor="thurs">Th</Label>
                </FormGroup>
                <FormGroup inline check style={{paddingTop: 35}}>
                  <Input className="form-check-input"
                         type="checkbox"
                         id="fri"
                         defaultChecked={getFormFieldValue(this.state.formData['fri'])}
                         onChange={(evt) => formsCheckboxUpdater(evt, this.state['formData'], this)}
                  />
                  <Label className="form-check-label" check htmlFor="fri">F</Label>
                </FormGroup>
                <FormGroup inline check style={{paddingTop: 35}}>
                  <Input className="form-check-input"
                         type="checkbox"
                         id="sat"
                         defaultChecked={getFormFieldValue(this.state.formData['sat'])}
                         onChange={(evt) => formsCheckboxUpdater(evt, this.state['formData'], this)}
                  />
                  <Label className="form-check-label" check htmlFor="sat">Sa</Label>
                </FormGroup>
                <FormGroup inline check style={{paddingTop: 35}}>
                  <Input className="form-check-input"
                         type="checkbox"
                         id="sun"
                         defaultChecked={getFormFieldValue(this.state.formData['sun'])}
                         onChange={(evt) => formsCheckboxUpdater(evt, this.state['formData'], this)}
                  />
                  <Label className="form-check-label" check htmlFor="sun">Su</Label>
                </FormGroup>
              </Col>
            </Fragment>
          )}
        </Row>
        <Row>
          <Col xs="3">
            <FormGroup>
              <Label for="recurStop">Stop</Label>
              <Input type="select" id="recurStop" placeholder=""
                     value={getFormFieldValue(this.state.formData['recurStop'])}
                     onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
              >
                <option value={""} disabled>Choose...</option>
                {(recurStopList || []).map((val, i) => {
                  return <option key={i} value={val.id}>{val.display}</option>
                })}
              </Input>
            </FormGroup>
          </Col>

          {this.state.formData['recurStop'] === "by" && (
            <Col xs="3">
              <FormGroup>
                <Label for="recurStopBy">By</Label>
                <InputGroup>
                  <Input
                    type="date"
                    id="recurStopBy"
                    placeholder="date"
                    value={getFormFieldValue(this.state.formData['recurStopBy'])}
                    onChange={(evt) => formsUpdater(evt, this.state['formData'], this, () => {
                    })}
                  />
                </InputGroup>
                <FormText color="muted">
                  ex. 10/23/2019
                </FormText>
              </FormGroup>
            </Col>
          )}

          {this.state.formData['recurStop'] === 'after' && (
            <Col xs="4" lg="4">
              <FormGroup inline check style={{paddingTop: 28}}>
                After
                <Input id="recurStopAfter" placeholder=""
                       size={"4"}
                       value={getFormFieldValue(this.state.formData['recurStopAfter'] || "1")}
                       onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                />
                occurrence(s)
              </FormGroup>
            </Col>
          )}

        </Row>
      </Fragment>
    )
  }

  render() {
    if (!this.state.dataLoaded) {
      return <Fragment>Loading...</Fragment>;
    }
    const containerStyle = {
      zIndex: 1999
    };

    const showAAR = this.originalDate ? this.originalDate.start / 1000 <= moment().unix() : false

    return (
      <Fragment>
        {this.state.showLMSPicker && (
          <LMSUserPicker isOpen={true} onClose={() => this.setState({showLMSPicker: false})}
                         onSelect={(lead) => this.attachLMSEntry(lead)}/>
        )}
        <Nav tabs>
          <NavItem>
            <NavLink
              className={classnames({active: this.state.activeTab === '1'})}
              onClick={() => this.toggleTab('1')}>
              Event
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({active: this.state.activeTab === '2'})}
              onClick={() => this.toggleTab('2')}>
              Additional
            </NavLink>
          </NavItem>
          {isNumber(this.props.edit) && showAAR && (
            <NavItem>
              <NavLink
                className={classnames({active: this.state.activeTab === '4'})}
                onClick={() => this.toggleTab('4')}>
                AAR
              </NavLink>
            </NavItem>
          )}
        </Nav>
        <TabContent activeTab={this.state.activeTab}>
          <TabPane tabId="1">
            <Row>
              <Col xs="6" lg="6">
                <FormGroup>
                  <Label for="subject">Subject</Label>
                  <Input
                    type="text"
                    id="subject"
                    value={getFormFieldValue(this.state.formData['subject'])}
                    onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                  />
                </FormGroup>
              </Col>
              <Col xs="4" lg="4">
                <FormGroup>
                  <Label for="appttype">Appointment Type</Label>
                  <Input type="select" id="appttype" placeholder=""
                         value={getFormFieldValue(this.state.formData['appttype'])}
                         onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                  >
                    <option value={""} disabled>Please Select...</option>
                    {(this.state.appttypes || []).map((val, i) => {
                      return <option key={i} value={val.id}>{val.display}</option>
                    })}
                  </Input>
                </FormGroup>
              </Col>
              <Col xs="1" lg="1">
                <FormGroup>
                  <Label for="color">Color</Label>
                  <TheColorPicker
                    color={getFormFieldValue(this.state.formData['colorOverride'])}
                    onChange={e => formsDataUpdater("colorOverride", e || "", this.state.formData, this)}/>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs="6" lg="6">
                <FormGroup>
                  <Label for="location">Location</Label>
                  <Input
                    type="text"
                    id="location"
                    value={getFormFieldValue(this.state.formData['location'])}
                    onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                  />
                </FormGroup>
              </Col>

              {(this.state.formData.appttype !== "-1" && this.state.formData.appttype !== -1) && (
                <Col xs="6" lg="6">
                  <FormGroup>
                    <Label for="location">LMS Entry</Label>
                    <div style={{display: "flex", alignItems: "center"}}>
                      {typeof getFormFieldValue(this.state.formData['attachedLeads']) === "object" ? (
                        <Fragment>
                          {`${getFormFieldValue(this.state.formData['attachedLeads']['fname'])} ${getFormFieldValue(this.state.formData['attachedLeads']['lname'])}`}
                          <Button color="link" className="lms-attach-lead-btns"
                                  onClick={() => EventClient.emit("LMS_ENTRY_EDIT", this.state.formData['attachedLeads']['id'])}> View </Button>
                          <Button color="link" className="lms-attach-lead-btns"
                                  onClick={() => formsDataUpdater('attachedLeads', undefined, this.state['formData'], this)}> Remove </Button>
                        </Fragment>
                      ) : (
                        <Fragment>
                          {this.props.scheduleLead ?
                            <Button
                              onClick={() => this.attachLMSEntry(this.props.scheduleLead, undefined, true)}>Attach {this.genLeadName(this.props.scheduleLead)}</Button>
                            :
                            <Button onClick={() => this.showAttachLMSPicker()}>Attach Lead</Button>
                          }

                        </Fragment>
                      )}
                    </div>
                  </FormGroup>
                </Col>
              )}

            </Row>
            <Row>
              <Col xs="6" lg="3">
                <FormGroup>
                  <Label for="startdate">Start Date</Label>
                  <InputGroup>
                    <Input
                      type="date"
                      id="startdate"
                      placeholder="date"
                      value={getFormFieldValue(this.state.formData['startdate'])}
                      onChange={(evt) => formsUpdater(evt, this.state['formData'], this, () => {
                        this.dateValidator('start');
                      })}
                    />
                  </InputGroup>
                  <FormText color="muted">
                    ex. 10/23/2019
                  </FormText>
                </FormGroup>
              </Col>

              <Col xs="6" lg="3">
                <FormGroup>
                  <Label for="starthour">Start Time</Label>
                  <div style={{display: 'flex'}}>
                    <Input type="select" id="starthour" placeholder=""
                           value={getFormFieldValue(this.state.formData['starthour'])}
                           onChange={(evt) => formsUpdater(evt, this.state['formData'], this, () => {
                             this.dateValidator('start');
                           })}
                           disabled={String(getFormFieldValue(this.state.formData['allDay'])) === "true"}
                    >
                      <option key={"-1"} value={""} disabled>HH</option>
                      {hourMarks.map((h, i) => <option key={i} value={h}>{zPad(String(h), 2)}</option>)}
                    </Input>
                    <Input type="select" id="startmin" placeholder=""
                           value={getFormFieldValue(this.state.formData['startmin'])}
                           onChange={(evt) => formsUpdater(evt, this.state['formData'], this, () => {
                             this.dateValidator('start');
                           })}
                           disabled={String(getFormFieldValue(this.state.formData['allDay'])) === "true"}
                    >
                      <option key={"-1"} value={""} disabled>MM</option>
                      {minMarks.map((m, i) => <option key={i} value={m}>{zPad(String(m), 2)}</option>)}
                    </Input>
                  </div>
                  <FormText color="muted">
                    ex. HH MM (15 45)
                  </FormText>
                </FormGroup>
              </Col>

              <Col xs="6" lg="3">
                <FormGroup>
                  <Label for="enddate">End Date</Label>
                  <InputGroup>
                    <Input
                      type="date"
                      id="enddate"
                      placeholder="date"
                      value={getFormFieldValue(this.state.formData['enddate'])}
                      onChange={(evt) => formsUpdater(evt, this.state['formData'], this, () => {
                        this.dateValidator('end');
                      })}
                    />
                  </InputGroup>
                  <FormText color="muted">
                    ex. 10/23/2019
                  </FormText>
                </FormGroup>
              </Col>
              <Col xs="6" lg="3">
                <FormGroup>
                  <Label for="endhour">End Time</Label>
                  <div style={{display: 'flex'}}>
                    <Input type="select" id="endhour" placeholder=""
                           value={getFormFieldValue(this.state.formData['endhour'])}
                           onChange={(evt) => formsUpdater(evt, this.state['formData'], this, () => {
                             this.dateValidator('end');
                           })}
                           disabled={String(getFormFieldValue(this.state.formData['allDay'])) === "true"}
                    >
                      <option key={"-1"} value={""} disabled>HH</option>
                      {hourMarks.map((h, i) => <option key={i} value={h}>{zPad(String(h), 2)}</option>)}
                    </Input>
                    <Input type="select" id="endmin" placeholder=""
                           value={getFormFieldValue(this.state.formData['endmin'])}
                           onChange={(evt) => formsUpdater(evt, this.state['formData'], this, () => {
                             this.dateValidator('end');
                           })}
                           disabled={String(getFormFieldValue(this.state.formData['allDay'])) === "true"}
                    >
                      <option key={"-1"} value={""} disabled>MM</option>
                      {minMarks.map((m, i) => <option key={i} value={m}>{zPad(String(m), 2)}</option>)}
                    </Input>
                  </div>
                  <FormText color="muted">
                    ex. HH MM (15 45)
                  </FormText>
                </FormGroup>
              </Col>
              <Col xs="4" lg="2">
                <FormGroup check inline>
                  <Input className="form-check-input"
                         type="checkbox"
                         id="allDay"
                         defaultChecked={getFormFieldValue(this.state.formData['allDay'])}
                         onChange={(evt) => formsCheckboxUpdater(evt, this.state['formData'], this)}
                  />
                  <Label className="form-check-label" check htmlFor="allDay">All Day</Label>
                </FormGroup>
              </Col>

              {(!isNumber(this.state.editID) && this.state.formData.appttype === "-1") && (
                <Col xs="4" lg="2">
                  <FormGroup check inline>
                    <Input className="form-check-input"
                           type="checkbox"
                           id="repeat"
                           defaultChecked={getFormFieldValue(this.state.formData['repeat'])}
                           onChange={(evt) => formsCheckboxUpdater(evt, this.state['formData'], this)}
                    />
                    <Label className="form-check-label" check htmlFor="repeat">Repeats/Clone</Label>
                  </FormGroup>
                </Col>
              )}

            </Row>
            {this.repeatForm()}
            <Row>
              <Col xs="12">
                <FormGroup>
                  <Label for="email">Details</Label>
                  <Input
                    type="textarea"
                    id="details"
                    cols={15}
                    style={{height: 150}}
                    value={getFormFieldValue(this.state.formData['details'])}
                    onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                  />
                </FormGroup>
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId="2">
            <Row>
              <Col xs={12}>
                <Label for="reminder">Reminder</Label>
                <Input type="select" id="reminder" placeholder=""
                       value={getFormFieldValue(this.state.formData['reminder']) || "2"}
                       onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                >
                  <option value="0">None</option>
                  <option value="1">Email Only</option>
                  <option value="2">Email and SMS</option>
                  <option value="3">SMS Only</option>
                </Input>
              </Col>
              <Col xs="12">
                <FormGroup>
                  <Label for="how_hear">How did they hear about us?</Label>
                  <Input type="select" id="how_hear" placeholder=""
                         value={getFormFieldValue(this.state.formData['how_hear'])}
                         onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                  >
                    <option value={""}>N/A</option>
                    {(howHearOptions || []).map((val, i) => {
                      return <option key={i} value={val.id}>{val.display}</option>
                    })}
                  </Input>
                </FormGroup>
              </Col>
              <Col xs="12">
                <FormGroup>
                  <Label for="notes">Notes</Label>
                  <Input
                    type="textarea"
                    id="notes"
                    style={{height: 200}}
                    value={getFormFieldValue(this.state.formData['notes'])}
                    onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                  />
                </FormGroup>
              </Col>
            </Row>
          </TabPane>

          {isNumber(this.props.edit) && showAAR && (
            <TabPane tabId={"4"}>
              <AAREntryEditor
                embedded
                calId={this.props.calId}
                edit={this.props.edit}
                apptType={this.state.formData.appttype || 2}
                attachedLead={this.state.formData['attachedLeads'] || {}}
                aarData={{
                  aar_status: this.state.formData.aar_status,
                  aar_comments: this.state.formData.aar_comments,
                  aar_uid: this.state.formData.aar_uid,
                  subStatus: this.state.formData.subStatus,
                  questionaire: this.state.formData.questionaire,
                  start_date: this.state.formData.startdate,
                  location: this.state.formData.location,
                  event_comments: this.state.formData.details
                }}
                onSave={(data) => {
                  this.setState({
                    formData: {
                      ...this.state.formData,
                      aar_status: data.aar_status,
                      aar_comments: data.aar_comments,
                    }
                  }, () => {
                    EventClient.emit("CALENDAR_REFRESH");
                  });
                }}
              />
            </TabPane>
          )}

        </TabContent>
        {this.state.showTransfer && (
          <TransferCalendarDialog currentCalendar={this.props.calId}
                                  eventId={this.props.edit}
                                  onSave={(newCalId, newEventId) => {
                                    this.setState({showTransfer: false}, () => {
                                      EventClient.emit("NAVIGATE", `/calendar/${newCalId}`);
                                      if (newEventId) {
                                        EventClient.emit("CALENDAR_ENTRY_EDIT", {eventId: newEventId, calId: newCalId});
                                      }
                                    });
                                  }}
                                  onClose={() => this.setState({showTransfer: false})}
          />
        )}
        {this.state.showReschedule && (
          <RescheduleCalendarDialog currentCalendar={this.props.calId}
                                    eventId={this.props.edit}
                                    eventData={this.state.formData}
                                    onSave={() => {
                                      this.setState({showReschedule: false}, () => {
                                        this.props.onClose && this.props.onClose();
                                        //EventClient.emit("CALENDAR_REFRESH");
                                      });
                                    }}
                                    onClose={() => this.setState({showReschedule: false})}
          />
        )}
        {this.state.showCancel && (
          <CancelCalendarDialog currentCalendar={this.props.calId}
                                eventId={this.props.edit}
                                apptType={this.state.formData.appttype}
                                onSave={() => {
                                  this.setState({showCancel: false}, () => {
                                    this.props.onClose && this.props.onClose();
                                  });
                                }}
                                onClose={() => this.setState({showCancel: false})}
          />
        )}
        {this.state.showMessage && (
          <MessageDialog currentCalendar={this.props.calId}
                         eventData={{
                           ...this.state.formData,
                           starttime: parseSeconds(this.state.formData.startdate, this.state.formData.starthour || 0, this.state.formData.startmin || 0, this.state.formData.allDay || false, "start"),
                           endtime: parseSeconds(this.state.formData.enddate, this.state.formData.endhour || 0, this.state.formData.endmin || 0, this.state.formData.allDay || 0, "end")
                         }}
                         apptType={this.state.formData.appttype || 2}
                         onClose={(note) => {
                           let notes = this.state.formData.notes || "";
                           if (note) notes = notes.concat("\r\n", note);
                           this.setState({showMessage: false, formData: {...this.state.formData, notes}});
                         }}
          />
        )}
      </Fragment>
    )
  }

  showAttachLMSPicker() {
    this.setState({showLMSPicker: true});
  }

  attachLMSEntry(lead, cb, append = false) {
    const obj = {
      attachedLeads: lead,
      details: this.genUserDetails(lead),
      subject: this.genSubject(lead, append),
    }
    formsMultiUpdater(obj, this.state['formData'], this, () => {
      this.setState({showLMSPicker: false}, () => {
        cb && cb()
      })
    });
  }

  genUserDetails(lead) {
    let details = getFormFieldValue(this.state.formData['details']);
    if (details.length > 0) details += "\r\n";
    details = details + (lead.maritalstatus === "Married" ? "Married " + (lead.spfname != "" ? "- Spouse Name: " + lead.spfname + " " + lead.splname : " - Spouse Unknown") + "\r\n" : "") + "Address:\r\n" + lead.address1 + (lead.address2 != "" ? ", " + lead.address2 + "\r\n" : "\r\n");
    details = details + "" + lead.city + ", " + lead.state + " " + lead.zip;
    if (lead.cellphone !== "") {
      details = details + "\r\nCell #: " + lead.cellphone;
    }
    if (lead.homephone !== "") {
      details = details + "\r\nHome #: " + lead.homephone;
    }
    if (lead.dutyphone !== "") {
      details = details + "\r\nDuty #: " + lead.dutyphone;
    }
    if (lead.homeemail !== "") {
      details = details + "\r\nHome Email: " + lead.homeemail;
    }
    if (lead.dutyemail !== "") {
      details = details + "\r\nDuty Email: " + lead.dutyemail;
    }
    return details;
  }

  genLeadName(lead) {
    return (lead.rank + " " + lead.fname + " " + lead.lname).replace("  ", " ")
  }

  genSubject(lead, append = false) {
    let subject = getFormFieldValue(this.state.formData['subject']);
    let leadName = this.genLeadName(lead);
    if (subject.length === 0) {
      return leadName;
    } else {
      return subject + (append ? " - " + leadName : "");
    }
  }

  removeExternal() {
    if (!confirm("Are you sure you want to delete this calendar entry?")) return false;
    const self = this;
    deleteData("calendar/delete/" + this.props.edit || 0, {}, this.props.token)
      .then((data) => {
        if (data.status === "Success") {
          self.props.onClose();
        }
      })
      .catch(error => {
        console.error(error);
      });
  }
}


// WEBPACK FOOTER //
// ./src/containers/Calendar/views/CalendarEntryEditor.js